import React from 'react';
import {useLanguage} from '../../context/LanguageContext';
import styles from './LanguageToggle.module.css';

export default function LanguageToggle() {
  const {lang, setLang} = useLanguage();

  return (
    <div className={styles.toggle} role="group" aria-label="Select language">
      <button
        className={`${styles.btn} ${lang === 'en' ? styles.active : ''}`}
        onClick={() => setLang('en')}
        aria-pressed={lang === 'en'}
        aria-label="English"
      >
        EN
      </button>
      <button
        className={`${styles.btn} ${lang === 'es' ? styles.active : ''}`}
        onClick={() => setLang('es')}
        aria-pressed={lang === 'es'}
        aria-label="Español"
      >
        ES
      </button>
    </div>
  );
}
